import { render } from "./category_menuComponent.vue?vue&type=template&id=8ed887ea"
import script from "./category_menuComponent.vue?vue&type=script&lang=js"
export * from "./category_menuComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__